import "./Footer.scss"
import suvaifusion from "../../assets/suvaifusion.svg"
import logo from "../../assets/logo.svg"
import { useSelector } from "react-redux";
import MapLocationComponent from "./MapLocationComponent";
import insta from "../../assets/insta.svg"
import fb from "../../assets/fb.svg"
import pin from "../../assets/pin.svg"
import tt from "../../assets/tiktok.svg"
import phone from "../../assets/phone.svg"
import mail from "../../assets/mail.svg"
import Button from "../button/Button";

const Footer = () => {
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);

    return (
        <div className="SuvaiFooter">
            <div className="SuvaiFooter-top">
                <div className="SuvaiFooter-top-item">
                    <img alt="" src={logo} className="SuvaiFooter-top-item-logo" />
                    <div className="SuvaiFooter-top-item-text">
                        Savour the best of Sri Lankan, Indian & Indo-Chinese cuisine at Suvai Fusion.
                    </div>
                </div>
                <div className="SuvaiFooter-top-item">
                    <div className="SuvaiFooter-top-item-content">
                        <div className="SuvaiFooter-top-item-header">
                            Visit
                        </div>
                        <div className="SuvaiFooter-top-item-text">
                            <img alt="" src={pin} />
                            {companyDetails?.address?.line1},  {companyDetails?.address?.city}, {companyDetails?.address?.postcode}, {companyDetails?.address?.state}
                        </div>
                    </div>
                    <div className="SuvaiFooter-top-item-content">
                        <div className="SuvaiFooter-top-item-header">
                            Talk
                        </div>
                        <div className="SuvaiFooter-top-item-text">
                            <img alt="" src={phone} />
                            {companyDetails?.contactNumber} </div>
                    </div>
                    <div className="SuvaiFooter-top-item-content">
                        <div className="SuvaiFooter-top-item-header">
                            write
                        </div>
                        <div className="SuvaiFooter-top-item-text">
                            <img alt="" src={mail} />
                            {companyDetails?.email}
                        </div>
                    </div>
                </div>
                <div className="SuvaiFooter-top-item">
                    <div className="SuvaiFooter-top-item-content">
                        {/* <div className="SuvaiFooter-top-item-header">
                            Reservations
                        </div>
                        <div className="SuvaiFooter-top-item-btnCont">

                            <Button text="Order Now"
                                width="100%" />
                            <Button text="Book a table"
                                width="100%"
                                type="SECONDARY" />
                        </div> */}
                        <div className="SuvaiFooter-top-item-content">
                            <div className="SuvaiFooter-top-item-header">
                                Hours
                            </div>
                            <div className="SuvaiFooter-top-item-text">
                                MONDAY - THURSDAY
                                <br />
                                12:00 PM - 10.00 PM</div>
                            <div className="SuvaiFooter-top-item-text">
                                FRIDAY - SUNDAY
                                <br />
                                12:00 PM - 11.00 PM</div>
                        </div>
                    </div>
                </div>
                <div className="SuvaiFooter-top-item">
                    <div className="SuvaiFooter-top-item-header">
                        Find Us
                    </div>
                    {companyDetails?.settings?.ShowAddressInMap && <MapLocationComponent lat={companyDetails?.address?.lat}
                        lng={companyDetails?.address?.lng}
                    />}
                    <div className="SuvaiFooter-top-item-header mrg-top15">
                        Follow Along
                    </div>
                    <div className="SuvaiFooter-top-item-social">
                        {company?.SocialMedias
                            ?.instagram && company?.SocialMedias
                                ?.instagram !== "" && <div
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.instagram, '_blank')
                                    }}
                                    className="SuvaiFooter-top-item-social-ic">
                                <img alt="" src={insta} />
                            </div>}
                        {company?.SocialMedias
                            ?.facebook && company?.SocialMedias
                                ?.facebook !== "" &&
                            <div className="SuvaiFooter-top-item-social-ic"
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} >
                                <img alt="" src={fb} />
                            </div>}

                        {company?.SocialMedias
                            ?.tiktok && company?.SocialMedias
                                ?.tiktok !== "" && <div className="SuvaiFooter-top-item-social-ic"
                                    onClick={() => {
                                        window.open(company?.SocialMedias
                                            ?.tiktok, '_blank')
                                    }}>
                                <img alt="" src={tt} />
                            </div>}
                    </div>
                </div>

            </div>
            <div className="SuvaiFooter-bottom">
                <div className="SuvaiFooter-bottom-text">
                    © 2026 Suvai Fusion. All Rights Reserved.
                </div>
                <img alt="" src={suvaifusion} className="SuvaiFooter-bottom-img" />
                <div className="SuvaiFooter-bottom-text right">
                    taste the difference
                </div>
            </div>
        </div>
    )
}
export default Footer